import MenuList from './menu-list';

export default MenuList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/MenuList/index.jsx